import {FUIFormContext} from "./form-context";
import {Injectable} from "@angular/core";
import {FUIContextType} from "./form-context-type";

/**
 * Context for controls being used in a regular edit content-layout. This is typically the default form-context.
 */
@Injectable()
export class FUIEditFormContext extends FUIFormContext {
    constructor() {
        super(FUIContextType.EDIT, "Edit");
    }
}
